export interface MissionPathRef {
  readonly missionTrn: string;
  readonly pathId: string | null | undefined;
}

function missionForPath(
  refTrn: string,
  missions: readonly MissionPathRef[]
): MissionPathRef | undefined {
  return missions.find(
    (mission) => mission.pathId === refTrn && mission.missionTrn.length > 0
  );
}

function missionForTrn(
  refTrn: string,
  missions: readonly MissionPathRef[]
): MissionPathRef | undefined {
  return missions.find(
    (mission) =>
      mission.missionTrn === refTrn &&
      mission.pathId != null &&
      mission.pathId.length > 0
  );
}

/** The server stores missionTrn. The tree selection is the path. */
export function toServerReferenceTrn(
  refTrn: string,
  missions: readonly MissionPathRef[]
): string {
  return missionForPath(refTrn, missions)?.missionTrn ?? refTrn;
}

/** A stored missionTrn selects that mission's path in the tree. */
export function toPathReferenceTrn(
  refTrn: string,
  missions: readonly MissionPathRef[]
): string {
  return missionForTrn(refTrn, missions)?.pathId ?? refTrn;
}

export function mapReferenceTrns(
  refTrns: Iterable<string>,
  mapOne: (refTrn: string) => string
): Set<string> {
  const mapped = new Set<string>();
  for (const refTrn of refTrns) {
    mapped.add(mapOne(refTrn));
  }
  return mapped;
}

export function sameReferenceTrns(
  left: ReadonlySet<string>,
  right: ReadonlySet<string>
): boolean {
  if (left.size !== right.size) {
    return false;
  }

  for (const refTrn of left) {
    if (!right.has(refTrn)) {
      return false;
    }
  }

  return true;
}

export function isMissionPathReferenceSelected(
  refTrn: string,
  missions: readonly MissionPathRef[],
  isSelected: (refTrn: string) => boolean
): boolean {
  if (isSelected(refTrn)) {
    return true;
  }

  const mission = missionForPath(refTrn, missions);
  return mission !== undefined && isSelected(mission.missionTrn);
}
